import React, { useEffect, useState } from 'react';
import '../css/boxCredit.css';
import { FaLeftLong } from 'react-icons/fa6';

const BoxCredit = ({
  accountNumber, creditType, dayDes, creditAmount ,Debt, availableDebt, paymentDay,
  amountPaid, cobranza, amountToFinish, state, isWide, client, onDetailsClick
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

  // Detectar el tamaño de la ventana
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720);
    };

    window.addEventListener('resize', handleResize);

    // Limpieza del evento
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // función para ubicar el color del crédito
  const getStyleAndTextByState = (state) => {
    if (state === 1) {
      return { color: 'green', text: 'Activo' }
    } else {
      return { color: 'red', text: 'Cancelado' }
    }
  };

  return (
    <>
      <div className={`box-credit ${isWide ? 'wide' : 'narrow'}`}>
        <div className='row'>
          <div className='col-md-3'>
            <h5>Cuenta <strong>{accountNumber}</strong></h5>
          </div>
          <div className='col-md-3'>
            <p>Tipo de crédito: <strong>{creditType}</strong></p>
          </div>
          <div className='col-md-4'>
            <p>Fecha de desembolso: <strong>{dayDes}</strong></p>
          </div>
          <div className='col-md-2'>
            {/* Botón en la posición original (pantallas grandes) */}
            {!isMobile && (
              <button
                className="btn btn-primary"
                style={{ float: 'right' }}
                onClick={() => onDetailsClick(accountNumber, client)}
              >
                Detalles
              </button>
            )}
          </div>
        </div>
        <div className='row' style={{ marginTop: '10px' }}>
          <div className='col-md-2'>
            <h5><strong>$ {creditAmount}</strong></h5>
            <p>Monto de Crédito</p>
          </div>
          <div className='col-md-2'>
            <h5><strong>$ {availableDebt}</strong></h5>
            <p>Saldo</p>
          </div>
          <div className='col-md-2'>
            <h5><strong>$ {Debt}</strong></h5>
            <p>Deuda Pendiente</p>
          </div>          
          <div className='col-md-2 parrafo2'>
            <p style={{ height: '2px' }}>Fecha <strong>{paymentDay}</strong></p>
            <h5 style={{ height: '2px',marginTop: '30px' }}><strong>$ {amountPaid}</strong></h5>
            <p style={{ height: '2px', marginTop: '15px' }}>Próximo pago</p>
          </div>
          <div className='col-md-3 parrafo'>
            <p style={{ height: '2px' }}>Cobranza pendiente: <strong>$ {cobranza}</strong></p>
            <p style={{ height: '2px' }}>Interés Moratorio pendiente: <strong>$ {amountToFinish}</strong></p>
            <p className='moratorio' style={{ height: '2px', marginTop: '20px', zIndex: '1'}}>Moratorio</p>
          </div>
          <div className='col-md-1'>
            {(() => {
              const { color, text } = getStyleAndTextByState(state);
              return (
                <p style={{ float: 'right', color: color }}>
                  {text}
                </p>
              )
            })()}
          </div>
        </div>

        {/* Botón debajo en pantallas pequeñas sin alterar el diseño original */}
        {isMobile && (
          <div className="row" style={{ marginTop: '10px' }}>
            <button
              className="btn btn-primary"
              style={{ width: '50%', alignItems: 'center' , marginLeft: '25%' }}
              onClick={() => onDetailsClick(accountNumber, client)}
            >
              Detalles
            </button>
          </div>
        )}
      </div>
    </>
  )
}

export default BoxCredit;
